module.exports = __webpack_public_path__ + "fonts/BradleyHandBold.ecb5c05.ttf";